// hooks/useInlineCopy.js
import { useCallback, useEffect, useRef, useState } from 'react';
import { copyText } from '../utils/copyText';

export function useInlineCopy(duration = 1200) {
    const [inlineCopied, setInlineCopied] = useState(null); // { group, id }
    const timerRef = useRef(null);

    const handleInlineCopy = useCallback(
        (group, id, text) => {
            if (timerRef.current) clearTimeout(timerRef.current);
            copyText(text).then(() => {
                setInlineCopied({ group, id });
                timerRef.current = setTimeout(() => setInlineCopied(null), duration);
            });
        },
        [duration]
    );

    useEffect(
        () => () => {
            if (timerRef.current) clearTimeout(timerRef.current);
        },
        []
    );

    return { inlineCopied, handleInlineCopy };
}
